import { Tabs as AntdTabs, TabsProps as AntdTabsProps } from 'antd';

export type ITabsProps = AntdTabsProps;

const Tabs = ({ ...props }: ITabsProps) => <AntdTabs {...props} />;

export default Tabs;
